import { render, staticRenderFns } from "./mainGroup.vue?vue&type=template&id=78127051&scoped=true&"
import script from "./mainGroup.vue?vue&type=script&lang=js&"
export * from "./mainGroup.vue?vue&type=script&lang=js&"
import style0 from "./mainGroup.vue?vue&type=style&index=0&id=78127051&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78127051",
  null
  
)

export default component.exports